export interface ITestReportDownloadUrl {
  url: string;
  key: string;
}

export interface IGetTestReportDownloadUrlResponse {
  getTestReportDownloadUrl: ITestReportDownloadUrl;
}

export const getTestReportDownloadUrlQuery = `
  query($key: String!) {
    getTestReportDownloadUrl(key: $key) {
      url
      key
    }
  }
`;
